import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import {
  addCommentRequest,
  postMobile3,
} from "../../common/redux/MasterLayoutCRUD";
import { dashboardSlice } from "./DashboardSlice";

const { actions } = dashboardSlice;

export const getDashboard = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return postMobile3(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.dashboardFetched({ data: response.data }));

          return response;
        }
      } else {
        throw new Error("Error api: getDashboard");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const getInboxDetail = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return postMobile3(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.inboxDetailFetched({ data: response.data }));

          return response;
        }
      } else {
        throw new Error("Error api: getInboxDetail");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const getInboxComment = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return postMobile3(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.inboxCommentFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: getInboxComment");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const clearInboxDetail = () => (dispatch) => {
  dispatch(actions.inboxDetailCleared());
};

export const createComment = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return addCommentRequest(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.commentCreated({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: createComment");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
